export {
  default as RestaurantReviewSummaryDialog,
  type RestaurantReviewSummaryDialogProps,
} from './dialog';
export { hasRestaurantReviewSummary } from './utils';
